<script lang="ts">
	import BreakPoint from '$lib/components/BreakPoint/BreakPoint.svelte';
	import Button from '$lib/components/Button/Button.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import { page } from '$app/stores';
	import { onMount } from 'svelte';
	import { _ } from 'svelte-i18n';

	const { hub } = getHubStores();

	let isCookieSet = true;
	let isBannerHidden = $page.data.isMobileApp;
	let formattedCookieConsentMessage = '<p></p>';

	onMount(() => {
		isCookieSet = doesCookieExist('cookie_consent');
	});

	const doesCookieExist = (cookieName: string) => {
		const searchKey = cookieName + '=';
		return (
			document.cookie.split(';').filter((item) => item.trim().startsWith(searchKey)).length > 0
		);
	};
	const setCookie = (
		cookieName: string,
		cookieValue: string,
		durationInMinutes: number | undefined = undefined
	) => {
		let expires = '';
		if (durationInMinutes != undefined) {
			let d = new Date();
			d.setTime(d.getTime() + durationInMinutes * 60 * 1000);
			expires = 'expires=' + d.toUTCString();
		}
		document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';

		isCookieSet = doesCookieExist('cookie_consent');
	};

	// cookie_policy is the new field, that holds the whole string to fully customize the message, which is not filled in by all customers
	// therefore it is required to check its existence and if not, we fall back to previously implemented fields (cookie_policy_hypertext and cookie_policy_url)
	// to generate the cookie consent message
	if (!$hub.settings.cookie_policy) {
		const generateCookieConsentMessage = (hypertext = 'privacy policy') => {
			const cookieConsentMessage = $_('common.cookie.popup.text', {
				values: {
					hypertext: `<a href=${
						$hub.settings.cookie_policy_url || ''
					} rel="noopener noreferrer" target="_blank">${hypertext}</a>`,
				},
			});

			return `<p>${cookieConsentMessage}</p>`;
		};

		if ($hub.settings.cookie_policy_hypertext && $hub.settings.cookie_policy_url) {
			const hypertext = $hub.settings.cookie_policy_hypertext;
			formattedCookieConsentMessage = generateCookieConsentMessage(hypertext);
		} else {
			formattedCookieConsentMessage = generateCookieConsentMessage();
		}
	}
</script>

{#if !isCookieSet && !isBannerHidden && $hub.settings.enable_cookie_consent}
	<div class="popup">
		<BreakPoint>
			<div class="container">
				<div class="consentMessageWrapper scroll">
					{@html $hub?.settings?.cookie_policy || formattedCookieConsentMessage}
				</div>
				<div class="consentButtons">
					<Button
						class="consentButton"
						displayType="primary"
						on:click={() => {
							setCookie('cookie_consent', 'yes', (365 * 24 * 60) / 2);
						}}>{$_('common.accept')}</Button>
				</div>
			</div>
		</BreakPoint>
	</div>
{/if}

<style>
	.popup {
		position: fixed;
		z-index: var(--z-index-Cookie-consent);
		max-block-size: 350px;
		inline-size: 100%;
		background: #fff;
		box-shadow: 3px 10px 30px rgb(0 0 0 / 25%);
		inset-block-end: 0;
	}

	.container {
		display: flex;
	}

	.consentButtons {
		padding: var(--gutterMedium);
	}

	.consentMessageWrapper {
		flex: 3;
		align-items: center;
		max-block-size: 300px;
		padding: var(--gutterMedium);
		overflow-y: auto;
	}

	:global(.consentMessageWrapper p) {
		margin: 0;
		color: black;
		font-size: var(--fontSizeSmall);
		font-weight: 400;
		line-height: 19.5px;
	}

	:global(.consentMessageWrapper a) {
		color: var(--primaryAccentColor);
	}

	:global(.consentButtons :nth-child(2)) {
		margin-inline-start: var(--gutterSmall);
	}

	@media screen and (max-width: 899px) {
		.consentButtons {
			flex: 1;
			padding: var(--gutterMedium);
		}

		:global(.consentButtons :nth-child(2)) {
			margin-block-start: var(--gutterSmaller);
			margin-inline-start: 0;
		}
	}
</style>
